import React from 'react';

import BudgetMoveConfirm, { KeepBalanceNote } from './BudgetMoveConfirm';
import { BUDGET_CC_LABELS, amountToReturn, inr } from '../../utilities/ccBudgetReturn';

/**
 * Shown before a CC's depreciation / accrued-interest value is lowered: the difference is taken back from the
 * budget CC that was credited earlier (CCC or CC-12), which must have that much in its Budget Balance.
 */
const LowerValueBudgetConfirm = ({ budgetCC, valueName, ccLabel, oldValue, newValue, onConfirm, onCancel }) => {
    const amount = inr(amountToReturn(oldValue, newValue));
    return (
        <BudgetMoveConfirm
            title={`Lowering the value takes budget back from ${budgetCC}`}
            confirmLabel="Yes, lower the value"
            onConfirm={onConfirm}
            onCancel={onCancel}
        >
            <p>
                Lowering the {valueName} of <span className="font-semibold">{ccLabel}</span> from{' '}
                <span className="font-semibold">{inr(parseFloat(oldValue) || 0)}</span> to{' '}
                <span className="font-semibold">{inr(parseFloat(newValue) || 0)}</span> will take{' '}
                <span className="font-semibold text-rose-600 dark:text-rose-400">{amount}</span> back from the budget of{' '}
                <span className="font-semibold">{BUDGET_CC_LABELS[budgetCC] || budgetCC}</span>.
            </p>
            <KeepBalanceNote budgetCC={budgetCC} amount={amount} />
        </BudgetMoveConfirm>
    );
};

export default LowerValueBudgetConfirm;
